import React from "react";
import { Button as AntdButton } from "antd";
import { cva } from "class-variance-authority";

import { cn } from "utils/cn";

const buttonVariants = cva(
  [
    "inline-flex items-center justify-center gap-2",
    "!font-open-sans-semibold !rounded-[5px] !shadow-none transition-colors",
    "disabled:!cursor-not-allowed disabled:!opacity-60",
    "disabled:hover:!bg-[inherit] disabled:hover:!text-[inherit] disabled:hover:!border-[inherit]",
    "aria-disabled:hover:!bg-[inherit] aria-disabled:hover:!text-[inherit] aria-disabled:hover:!border-[inherit]"
  ].join(" "),
  {
    variants: {
      variant: {
        primary: [
          "!bg-brand !text-white !border-brand",
          "hover:!bg-white hover:!text-brand hover:!border-brand",
          "disabled:!bg-brand disabled:!text-white disabled:!border-brand",
          "disabled:hover:!bg-brand disabled:hover:!text-white disabled:hover:!border-brand"
        ].join(" "),
        outline: [
          "!bg-white !text-[#333333] !border-[#cccccc]",
          "hover:!bg-white hover:!text-brand hover:!border-brand",
          "disabled:!bg-white disabled:!text-[#333333] disabled:!border-[#cccccc]",
          "disabled:hover:!bg-white disabled:hover:!text-[#333333] disabled:hover:!border-[#cccccc]"
        ].join(" "),
        ghost: [
          "!bg-transparent !border-none !text-brand !shadow-none",
          "hover:!bg-surface hover:!text-brand",
          "disabled:!bg-transparent disabled:!text-brand",
          "disabled:hover:!bg-transparent disabled:hover:!text-brand"
        ].join(" "),
        ghostIcon: [
          "!bg-transparent !border-gray !text-brand !shadow-none",
          "hover:!bg-surface hover:!text-brand",
          "disabled:!bg-transparent disabled:!text-brand",
          "disabled:hover:!bg-transparent disabled:hover:!text-brand"
        ].join(" "),
        destructive: [
          "!bg-red-600 !text-white !border-red-600",
          "hover:!bg-white hover:!text-red-600 hover:!border-red-600",
          "disabled:!bg-red-600 disabled:!text-white disabled:!border-red-600",
          "disabled:hover:!bg-red-600 disabled:hover:!text-white disabled:hover:!border-red-600"
        ].join(" "),
        destructiveOutline: [
          "!bg-white !text-red-600 !border-red-600",
          "hover:!bg-red-600 hover:!text-white hover:!border-red-600",
          "disabled:!bg-white disabled:!text-red-600 disabled:!border-red-600",
          "disabled:hover:!bg-white disabled:hover:!text-red-600 disabled:hover:!border-red-600"
        ].join(" ")
      },
 
      size: {
        sm: "!h-7 !px-2.5 !text-xs",
        default: "!h-8 !px-4 !text-sm",
        lg: "!h-10 !px-6 !text-sm",
        icon: "!h-8 !w-11 !p-0"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
);

const Button = React.forwardRef(({ variant, size, className, ...props }, ref) => {
  return (
    <AntdButton
      ref={ref}
      {...props}
      type="default"
      className={cn(buttonVariants({ variant, size }), className)}
    />
  );
});

Button.displayName = "Button";

export { Button, buttonVariants };
export default Button;
